import React, { lazy, Suspense } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  PortfolioContentConfig,
  portfolioUrlRouting,
} from "../../../config/portfolio-content-config";
import LoadingScreen from "../../../components/loader/loading-screen";
import "../portfolio.css";
import SentryVideoTestimonial from "../../../components/videos/sentry-video";

const HeroBanner = lazy(() => import("./components/hero"));
const InfoSection = lazy(() => import("./components/info-section"));
const KeyInsights = lazy(() => import("./components/key-insights"));
const TechnologyList = lazy(() => import("./components/technology-list"));
const TestimonialVideoPlayer = lazy(() =>
  import("../../../components/videos/testimonial-video")
);
const BrandsCarousel = lazy(() =>
  import("../../../components/carousels/brands-carousel")
);
const TestimonialCarousel = lazy(() =>
  import("../../../components/carousels/testimonial-carousel")
);
const ContactForm = lazy(() =>
  import("../../../components/forms/contact-form")
);

const PortfolioBaseLayout = () => {
  const currentPath = window.location.pathname;
  const findPath = portfolioUrlRouting.find(
    (data) => data.pathname === currentPath
  );
  const page = PortfolioContentConfig.find(
    (data) => data.pageName === findPath?.pageName
  );

  if (!page) return null;

  return (
    <Suspense fallback={<LoadingScreen />}>
      <section className="layout-wrapper">
        <HeroBanner
          title={page.title}
          content={page.content}
          backgroundImage={page.backgroundImage}
        />
        <InfoSection
          image={page.infoSection?.image}
          alt={page.infoSection?.alt}
          paragraphs={page.infoSection?.paragraphs}
        />
        <KeyInsights
          title={page.infoSection?.insights?.title}
          info={page.infoSection?.insights?.info}
        />
        <TechnologyList
          title={page.technologyList?.title}
          image={page.technologyList?.image}
          alt={page.technologyList?.alt}
        />
        <Container>
          <Row>
            <Col xs="12" lg="6">
              <TestimonialVideoPlayer />
            </Col>
            <Col xs="12" lg="6">
              <SentryVideoTestimonial />
            </Col>
          </Row>
        </Container>
        <BrandsCarousel />
        <TestimonialCarousel />
        <ContactForm />
      </section>
    </Suspense>
  );
};

export default React.memo(PortfolioBaseLayout);
